import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const ShowSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" width="18" height="18">
        <path fill="currentColor" fillRule="evenodd" d="M12 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path>
        <path fill="currentColor"
              d="M16.91 8.8C15.31 4.99 12.18 3 9 3 5.82 3 2.7 4.98 1.08 8.8L1 9l.08.2C2.7 13.02 5.82 15 9 15c3.18 0 6.3-1.97 7.91-5.8L17 9l-.09-.2ZM9 14c-2.69 0-5.42-1.63-6.91-5 1.49-3.37 4.22-5 6.9-5 2.7 0 5.43 1.63 6.92 5-1.5 3.37-4.23 5-6.91 5Z"></path>
    </svg>


)

const Show: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ShowSvg}
    </SvgIcon>
)

export default Show